import {
    MODAL_COSTCENTER_KEY_VALUE   ,
    MODAL_COSTCENTER_INPUT_SEARCH,
    MODAL_COSTCENTER_SET_RESULT  
} 
from './actionTypes';

export function setModalCostCenterKeyAction(refKey) {
  
    return function (dispatch) {
        dispatch({
            type: MODAL_COSTCENTER_KEY_VALUE,
            payload: refKey
        })

    }
}